/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_Warningtitle1Inputs */

const en_welcome_terms_warningtitle1 = /** @type {(inputs: Welcome_Terms_Warningtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action Required: Accept Terms & Services`)
};

/**
* | output |
* | --- |
* | "Action Required: Accept Terms & Services" |
*
* @param {Welcome_Terms_Warningtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_terms_warningtitle1 = /** @type {((inputs?: Welcome_Terms_Warningtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_Warningtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_warningtitle1(inputs)
});
export { welcome_terms_warningtitle1 as "welcome_terms_warningTitle" }